"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectDropdown = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var FindIndex_1 = require("../../utils/FindIndex");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var ListItemUtils_1 = require("../List/ListItemUtils");
var SelectDropdown_1 = require("./SelectDropdown");
/**
 * `SingleSelectDropdown` implements Tableau's version of an HTML `<select>`.
 * It is implemented as a `DropdownButton` with a parameterized `List` popup.
 * The caller can provide a `List`, `FilteringList`, `LocallyFilteringList`, or any other component which satisfies the `ListProps` interface.
 *
 * By default, closes the popup upon selection change — unless the `onOpen` prop is provided. In that case, the caller must close the dropdown
 * manually when appropriate. To do so, save a ref to the dropdown and call `toggle(false)` on it.
 */
var SingleSelectDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(SingleSelectDropdown, _super);
    function SingleSelectDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typeAheadQuery = '';
        _this.typeAheadTimeoutHandle = 0;
        _this.keyDownHandlers = Object.freeze({
            'Home': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, -1, +1); },
            'End': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, items.length, -1); },
            'ArrowUp': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, ListItemUtils_1.findIndexOfItemWithValue(items, _this.props.value), -1); },
            'ArrowDown': function (items) { return ListItemUtils_1.findSelectableItemIndex(items, ListItemUtils_1.findIndexOfItemWithValue(items, _this.props.value), +1); },
        });
        _this.handleKeyDown = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (_this.props.disabled || !_this.keyDownHandlers[e.key]) {
                return;
            }
            var items = _this.props.list.props.items;
            var newSelectedItemIndex = _this.keyDownHandlers[e.key](items);
            e.preventDefault();
            e.stopPropagation();
            if (!items[newSelectedItemIndex]) {
                _this.toggle(true); // if we can't find an item, open the dropdown instead, the items are probably being lazily loaded
                return;
            }
            var newValue = items[newSelectedItemIndex].value;
            if (newValue !== _this.props.value) {
                _this.handleSelect(newValue);
            }
        }, function (e) { var _a, _b; return (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.handleKeyPress = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (_this.props.disabled || e.key === ' ' || e.key === 'Enter' || e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            window.clearTimeout(_this.typeAheadTimeoutHandle);
            _this.typeAheadTimeoutHandle = window.setTimeout(function () { return _this.typeAheadQuery = ''; }, 500);
            _this.typeAheadQuery += e.key;
            var items = _this.props.list.props.items;
            var currentIndex = FindIndex_1.findIndex(items, function (item) { return item.value === _this.props.value; });
            function lookFor(query) {
                // single-character queries start after the current item, but multiple-character queries start on the current item
                var startAt = currentIndex + (query.length > 1 ? 0 : 1);
                return FindIndex_1.findIndex(items, function (item) { return ListItemUtils_1.isSelectableItem(item) && item.value.toLowerCase().indexOf(query.toLowerCase()) === 0; }, startAt);
            }
            var nextIndex = lookFor(_this.typeAheadQuery);
            if (nextIndex < 0) {
                nextIndex = lookFor(e.key);
            }
            if (nextIndex >= 0 && currentIndex !== nextIndex) {
                _this.handleSelect(items[nextIndex].value);
                e.preventDefault();
                e.stopPropagation();
            }
        }, function (e) { var _a, _b; return (_b = (_a = _this.props).onKeyPress) === null || _b === void 0 ? void 0 : _b.call(_a, e); });
        _this.handleSelect = function (value) {
            var _a, _b;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
            if (!_this.props.onOpen) {
                _this.toggle(false);
            }
        };
        return _this;
    }
    SingleSelectDropdown.prototype.makeListProps = function () {
        return {
            onSelect: this.handleSelect,
            onSelectAll: undefined,
            selectOnEnterKey: true,
            selectedValue: this.props.value,
            selectedValues: undefined,
        };
    };
    SingleSelectDropdown.prototype.renderButtonContent = function () {
        var _a = this.props, children = _a.children, list = _a.list, value = _a.value;
        var selectedItem = list.props.items.find(function (item) { return item.value === value; });
        return children !== null && children !== void 0 ? children : ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.content) || value || '');
    };
    SingleSelectDropdown.prototype.render = function () {
        return React.cloneElement(_super.prototype.render.call(this), {
            onKeyDown: this.handleKeyDown,
            onKeyPress: this.handleKeyPress,
        });
    };
    return SingleSelectDropdown;
}(SelectDropdown_1.SelectDropdown));
exports.SingleSelectDropdown = SingleSelectDropdown;
//# sourceMappingURL=SingleSelectDropdown.js.map